import { useNavigate } from 'react-router-dom';
import './NameLink.css';

interface NameLinkProps {
  name: string;
  className?: string;
}

function NameLink({ name, className }: NameLinkProps) {
  const navigate = useNavigate();

  return (
    <span
      className={`name-link ${className ?? ''}`}
      role="link"
      tabIndex={0}
      onClick={() => navigate(`/wc26-user/${encodeURIComponent(name)}`)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') navigate(`/wc26-user/${encodeURIComponent(name)}`);
      }}
    >
      {name}
    </span>
  );
}

export default NameLink;
